import { data } from '../../svg/ConditionCircle/data';
import { makeIcon } from '../makeIcon';

export const ConditionCircle = makeIcon(data, 'condition_circle', 'ConditionCircle');

export default ConditionCircle;
